/**
 * Iter59 — TareasTab extraído de ClienteDetalle.jsx para reducir monolito.
 *
 * Recibe data + callbacks del padre (no posee state global de tareas).
 * State local: solo los filtros de UI.
 */
import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Plus, CheckSquare, Pencil, Trash2, Clock } from 'lucide-react';

export const TareasTab = ({ tareasCliente, onNueva, onEditar, onBorrar, onToggleEstado }) => {
  const [estado, setEstado] = useState('');
  const [prioridad, setPrioridad] = useState('');

  const filtradas = tareasCliente.filter((t) =>
    (!estado || t.estado === estado) &&
    (!prioridad || t.prioridad === prioridad)
  );

  return (
    <div data-testid="tab-tareas-content">
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-ink-500">Tareas asociadas a este cliente (pueden venir de visitas o ser independientes).</p>
        <Button className="bg-brand-500 hover:bg-brand-600 text-white" onClick={onNueva} data-testid="btn-nueva-tarea-cliente">
          <Plus className="w-4 h-4 mr-1.5" /> Nueva tarea
        </Button>
      </div>

      <Card className="p-3 mb-3 border-ink-200 bg-white flex flex-wrap items-center gap-2">
        <select className="h-8 rounded-md border border-ink-200 bg-white text-sm px-2 text-ink-700" value={estado} onChange={(e) => setEstado(e.target.value)} data-testid="cli-filter-estado">
          <option value="">Todos los estados</option>
          <option value="pendiente">Pendiente</option>
          <option value="en_curso">En curso</option>
          <option value="hecha">Hecha</option>
          <option value="cancelada">Cancelada</option>
        </select>
        <select className="h-8 rounded-md border border-ink-200 bg-white text-sm px-2 text-ink-700" value={prioridad} onChange={(e) => setPrioridad(e.target.value)} data-testid="cli-filter-prioridad">
          <option value="">Todas las prioridades</option>
          <option value="alta">Prioridad alta</option>
          <option value="media">Prioridad media</option>
          <option value="baja">Prioridad baja</option>
        </select>
      </Card>

      {filtradas.length === 0 ? (
        <Card className="p-10 text-center text-ink-400 bg-white border-ink-200">
          {tareasCliente.length === 0 ? 'Sin tareas para este cliente.' : 'Sin resultados con estos filtros.'}
        </Card>
      ) : (
        <Card className="border-ink-200 bg-white divide-y divide-ink-100">
          {filtradas.map((t) => (
            <div key={t.id} className="p-4 flex items-start gap-3 hover:bg-ink-50" data-testid={`tarea-cliente-${t.id}`}>
              <button
                onClick={() => onToggleEstado(t)}
                className="mt-0.5"
                data-testid={`tarea-cliente-toggle-${t.id}`}
                aria-label={t.estado === 'hecha' ? 'Marcar pendiente' : 'Marcar hecha'}
              >
                <CheckSquare className={`w-5 h-5 ${t.estado === 'hecha' ? 'text-emerald-600' : 'text-ink-300'}`} />
              </button>
              <div className="flex-1 min-w-0">
                <p className={`font-semibold text-ink-900 ${t.estado === 'hecha' ? 'line-through text-ink-400' : ''}`}>{t.titulo}</p>
                {t.descripcion && <p className="text-xs text-ink-500 mt-0.5">{t.descripcion}</p>}
                <div className="flex flex-wrap items-center gap-2 mt-1 text-[11px] text-ink-500">
                  <Badge className="text-[10px] bg-white border border-ink-200 text-ink-600">{t.estado}</Badge>
                  <span>prioridad {t.prioridad}</span>
                  {t.vencimiento && <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {t.vencimiento}</span>}
                  <span>· {t.asignado_nombre || '—'}</span>
                  {t.visita_id && <span>· de una visita</span>}
                </div>
              </div>
              <div className="flex gap-1">
                <button onClick={() => onEditar(t)} className="p-1.5 rounded hover:bg-ink-100 text-ink-600" title="Editar" data-testid={`tarea-cliente-editar-${t.id}`}><Pencil className="w-4 h-4" /></button>
                <button onClick={() => onBorrar(t)} className="p-1.5 rounded hover:bg-red-50 text-red-600" title="Eliminar" data-testid={`tarea-cliente-borrar-${t.id}`}><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
};

export default TareasTab;
